// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_UpdateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_categorias/update
 *
 * Returns the updated expense category id.
 * Wire shape: { despesa_categoria_id: <int> }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DespesasCategorias_UpdateResponseDados {
despesa_categoria_id?: number
}

export type DespesasCategorias_UpdateResponse = ApiResponse<DespesasCategorias_UpdateResponseDados>;

registerResponseContract('DespesasCategorias_UpdateResponse', {
  despesa_categoria_id: { type: 'number',  required: false },
})
